<template>
  <div class="board ma-0">
    
  </div>
</template>
<script>
import BacteriaGrowth from "@/components/BacteriaGrowth.vue";
import Respiration from "@/components/Respiration.vue";
import Photosynthesis from "@/components/Photosynthesis.vue";

export default {
  name: "board",
  components: {
    BacteriaGrowth,
    Respiration,
    Photosynthesis,
  },
  data: function () {
    return {
      name: "",
      role: null,
    };
  },
  mounted: function () {
    this.$ga.page("/board/" + this.$route.params.experiment_name);
    this.name = this.$route.params.experiment_name;
    var ga_counter = 0;
/*
    setInterval(function () {
      ga_counter += 10;
      this.$ga.event(
        "Experiment",
        "stay_" + ga_counter + "_mins",
        this.$route.params.experiment_name
      );
    }, 10 * 60 * 1000);
*/    
  },
  methods: {},
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>